import {getDefaultState, SurveyState} from "./state";

export const SET_SURVEYS = (state: SurveyState, payload) => {
  state.surveys = payload
}

export const SET_ACTIVE_SURVEY = (state: SurveyState, payload) => {
  state.surveyData = []
  state.reportSettings = {}
  if (payload) state.activeSurvey = payload
}

export const SET_ACTIVE_SURVEY_USER_COUNT = (state: SurveyState, payload) => {
  state.activeSurveyUserCount = payload
}

export const SET_ACTIVE_TEMPLATE = (state: SurveyState, payload) => {
  state.templateObject = payload
}

export const SET_SURVEY_DATA = (state: SurveyState, payload) => {
  state.surveyData = payload
}

export const SET_SORT = (state: SurveyState, sort) => {
  state.sortBy = sort
}

export function ADD_SURVEY (state: SurveyState, newSurvey) {
  state.surveys.push(newSurvey)

  // legacy; in the past there used to be a dummy-survey added to the store when adding a new one
  const isnew = state.surveys.findIndex(s => s.isNew)
  if (isnew > -1) state.surveys.splice(isnew, 1)
}

export function RESET (state: SurveyState) {
  const initialState = getDefaultState()
  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key]
  })
}
